<div style="border: 1px dashed">
  <form>
    <app-layout-container fluid>
      <app-layout-row>
        <app-layout-column [width]="4">
          <span>Controls and decorators</span>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
            <app-header headerText="My Header" infoText="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Doloribus nemo debitis dolor fugiat quia iusto eaque esse et hic repellendus nisi aut veniam delectus, ex corrupti! Laboriosam eligendi eos reprehenderit. Accusantium quod deleniti vitae dolorum voluptatum deserunt placeat consequuntur asperiores eveniet possimus repellat modi odit, id, non distinctio perferendis aperiam sint necessitatibus! Debitis quam est hic dicta consequuntur sequi quo.Voluptatibus, minima architecto ut delectus magnam molestias necessitatibus recusandae eligendi quaerat nisi pariatur eaque ad libero quo animi. Necessitatibus sequi nostrum eius quia dolore nulla voluptate saepe neque aliquam adipisci.Dolores corrupti quibusdam omnis modi, perferendis officia atque dolorum harum veritatis quos quis necessitatibus laudantium."></app-header>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-textbox decorator caption="Name" [ngModel]="name" required name="name" infoText="Please enter your name"></app-textbox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-textbox decorator caption="Address" [ngModel]="address" name="address" infoText="Please enter your full address including street, city, and postal code. This is a required field."></app-textbox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-checkbox decorator="right-side" caption="Accept all terms" [ngModel]="acceptTerms" name="acceptTerms" infoText="Please acknowledge that you accept all term as required. Because the terms are top secret, you must accept them without any knowledge of the details."></app-checkbox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-datetimebox decorator datetime required caption="DateTime" [ngModel]="datetime()" name="datetime" [minDate]="minDateTime()" [maxDate]="maxDateTime()" infoText="Please fill Date time"></app-datetimebox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-datetimebox decorator date caption="Date" [ngModel]="date()" name="date" infoText="Please fill Date"></app-datetimebox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-datetimebox decorator time caption="Time" [ngModel]="time()" name="time" infoText="Please fill time"></app-datetimebox>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-password decorator caption="Password (Hashed)" [ngModel]="passwordHash" name="passwordHash" infoText="Please fill password" section="templateHash" mode="hash"></app-password>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-password decorator caption="Password (Secret)" [ngModel]="passwordSecret" name="passwordSecret" infoText="This is a secret based password" section="templateSecret" mode="secret" [allowShowPassword]="true" required></app-password>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-radio-button-group decorator
              name="size"
              caption="Size"
              infoText="Please select a size"
              [dataSource]="possibleSizes"
              [value]="selectedSize"
              [valueExpr]="'value'"
              [displayExpr]="'description'"
              [itemTemplate]="itemTemplate"
              (valueChange)="onSizeChange($event)">

              <ng-template #itemTemplate let-data>
                  <div class="radio-item">{{data.description}}</div>
              </ng-template>
          </app-radio-button-group>
          <p>Selected Size: {{selectedSize}}</p>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <app-toggle-button decorator
              name="toggle"
              caption="Color"
              infoText="Please select options"
              [buttons]="colors"
              [value]="selectedColors"
              (valueChange)="onColorChange($event)">
          </app-toggle-button>
          <p>Selected Color: {{selectedColors}}</p>
        </app-layout-column>
      </app-layout-row>

      <app-layout-row>
        <app-layout-column [width]="4" [offset]="4">
          <div>DateTimeService Test</div>

          <div>Format</div>
          <div>DateTime Format: {{this.dateTimeFormat()}}</div>
          <div>Date Format: {{this.dateFormat()}}</div>
          <div>Time Format: {{this.timeFormat()}}</div>
          <br>
          <div>Formatted</div>
          <div>DateTime: {{this.formattedDateTime()}}</div>
          <div>Date: {{this.formattedDate()}}</div>
          <div>Time: {{this.formattedTime()}}</div>
          <div>String: {{this.formattedFromString()}}</div>
          <div>Timestamp: {{this.formattedFromTimestamp()}}</div>
          <div>Midnight: {{this.formattedMidnight()}}</div>
          <div>End Of Day: {{this.formattedEndOfDay()}}</div>
          <div>Leap Day: {{this.formattedLeapDay()}}</div>
          <hr>
        </app-layout-column>
      </app-layout-row>
    </app-layout-container>
  </form>
</div>
